import { render, staticRenderFns } from "./VideoRectangleTile.vue?vue&type=template&id=76cff64c"
import script from "./VideoRectangleTile.vue?vue&type=script&lang=js"
export * from "./VideoRectangleTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports